import * as React from 'react'

import { DOMRef, ScopedCSSRules, TextProps } from '@dna/react-types'
import { css, cx, textStyles } from '@dna/core'

import { filterDOMProps, fontStyleProps, useStyleProps } from '../utils'

function Text(props: TextProps, ref: DOMRef<HTMLElement>) {
  let {
    UNSAFE_className,
    UNSAFE_style,
    as: ElementType = 'span',
    children,
    css: styleProps = {},
    level = 'medium',
    ...otherProps
  } = props

  let {
    styleProps: { className, style },
  } = useStyleProps(
    { ...styleProps, UNSAFE_className, UNSAFE_style },
    fontStyleProps
  )

  let styles = textStyles({ level })

  return (
    <ElementType
      {...filterDOMProps(otherProps)}
      className={cx(
        css(styles as ScopedCSSRules),
        css(style as ScopedCSSRules),
        className
      )}
      ref={ref}
    >
      {children}
    </ElementType>
  )
}

/**
 * Text renders text with no specific semantic meaning.
 *
 * @name
 * Text
 *
 * @see
 * https://dna.telstrahealth.com/components/text
 *
 * @example
 * <Text as="p">Hello there!</Text>
 *
 * */
let _Text = React.forwardRef(Text)
export { _Text as Text }
